import {Component} from '@angular/core';
import {select} from "@angular-redux/store";
import {Observable} from "rxjs";
import {TranslateService} from '@ngx-translate/core';
import {environment} from "../environments/environment";
import {appProjectInfo} from "../info.app";
import {Languages} from "./models/common";

declare var require: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css', './app.component.mobile.css']
})
export class AppComponent {
  @select(['appContext', 'frameMode']) inFrame$: Observable<boolean>;

  constructor(public translate: TranslateService) {
    const userLang = sessionStorage.getItem('user_lang');
    translate.addLangs([Languages.en, Languages.zh, Languages.ja, Languages.es, Languages.pt]);
    translate.use(userLang && userLang !== '' ? userLang : Languages.en);

    if (!environment.production) {
      console.log(`Debug Version ${appProjectInfo.version} Build ${appProjectInfo.build} ${appProjectInfo.verName}`);
    }
  }

}
